import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { trackingUrl: String }

  connect() {
    this.#dispatchReadyEvent()
  }

  #dispatchReadyEvent() {
    this.dispatch('ready', { detail: { trackingUrl: this.trackingUrlValue } })
  }
}
